import React, { useState, useEffect } from 'react';
import './index.css';
import { CAREER_HERO_ASSETS } from './assets';
import { Typography } from '@mui/material';
const courses = ["Green Jobs", "AI Engineering", "Product Management", "Entrepreneurship Program"];

export default function CoursesOffered() {
  const [idx, setIdx] = useState(1); // Starting with AI Engineering

  useEffect(() => {
    const timer = setInterval(() => setIdx((prev) => (prev + 1) % 4), 3000);
    return () => clearInterval(timer);
  }, []);

  return (
  <section className="courses-wrapper">
    <div className="courses-container">
      <div className="courses-grid">
        {/* Left Column */}
        <div className="courses-text">
          <Typography className="sub-header">
            Courses offered
          </Typography>
          
          <h2 className="main-course-title">
            <span className="title-first-word">
              {courses[idx].split(' ')[0]}
            </span> 
            <span className="title-remaining-words">
              {courses[idx].split(' ').slice(1).join(' ')}
            </span>
          </h2>
          
          <div className="bars-row">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className={`bar ${i === idx ? 'active' : ''}`} />
            ))}
          </div>

          
        </div>

        {/* Right Column */}
        <div className="courses-image-box">
          <div className="image-inner-wrapper">
            <img 
              src={CAREER_HERO_ASSETS.heroImage} 
              alt="Course Preview" 
              className="main-preview-img"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);
}